<template>
	<div class="page_ blue_">
		<p class="title_">{{ $t('hdetail.medicalRecordQuery') }}</p>
		<div class="datalist_b">
			<div class="datalist_" v-if="datalist.length > 0">
				<div class="item_" v-for="(item, index) in datalist" :key="index">
					<div class="top_">
						<span>{{ item.provider_name }}</span>
						<span>
							<span class="circle"></span>
							{{ item.provider_level }}
						</span>
					</div>
					<p>{{ $t('hdetail.hospitalProperty') }}：{{ item.provider_type }}</p>
					<p>{{ $t('hdetail.hospitalClass') }}：{{ item.provider_catg }}</p>
					<p>{{ $t('hdetail.patient') }}：{{ item.patient }}</p>
					<p>
						{{ $t('hdetail.date') }}：{{
							item.docrcvdt != '' && item.docrcvdt != null ? item.docrcvdt.substring(0, 10) : '--'
						}}
					</p>
					<p>{{ $t('hdetail.diagnosis') }}：{{ item.primaryDiagnosis }}</p>
					<p v-if="item.benefitRemarkFlag" :style="{ color: '#e94b2c' }">{{ $t('hdetail.noReduceTip') }}</p>
					<div
						class="bottom_"
						@click="goComment(item.claims_id, item.provider_name, item.provider_code, item.evaluationList)"
					>
						<span class="icon_" v-if="item.isEvaluation == 'N'"></span>
						{{ item.isEvaluation == 'Y' ? $t('hdetail.question7') : $t('hdetail.question5') }}
					</div>
				</div>
			</div>
			<div class="nodata_" v-else>
				<img src="../assets/medilinkPC/nodata.jpg" alt="" />
			</div>
		</div>

		<div class="pagination_">
			<span style="margin-right:10px;">
				{{ $t('claimDetails[21]') || '共' }}{{ pagination.totalPage }}{{ $t('claimDetails[22]') || '页' }}
			</span>
			<a-pagination
				show-quick-jumper
				:default-current="1"
				:pageSize="pagination.pageSize"
				:total="pagination.totalNum"
				@change="pageChange"
			/>
		</div>
	</div>
</template>
<script>
import api from '@/utils/api';
export default {
	data() {
		return {
			pagination: {
				pageNum: 1,
				pageSize: 9,
				totalNum: 0,
				totalPage: 1
			},
			datalist: [],
			originList: [],
			lanuage: 'CHINAESE'
		};
	},
	mounted() {
		if (this.$i18n.locale == 'zh-cn') {
			this.lanuage = 'CHINAESE';
		} else {
			this.lanuage = 'ENGLISH';
		}
		this.fetchData();
	},
	methods: {
		pageChange(pageNum) {
			this.pagination.pageNum = pageNum;
			this.toPage();
		},
		toPage() {
			this.datalist = JSON.parse(JSON.stringify(this.originList));
			let page = (this.pagination.pageNum - 1) * 9;
			this.datalist = this.datalist.splice(page, this.pagination.pageSize);
			this.pagination.totalNum = this.datalist.length;
		},
		fetchData() {
			api.getMediciRecordInfo({ lanuage: this.lanuage }).then(res => {
				if (res.data.code === 200) {
					this.originList = res.data.data;
					this.datalist = res.data.data;
					this.pagination.totalNum = this.datalist.length;
				}
			});
		},
		goComment(id, name, code, evaluationList) {
			if (evaluationList) {
				localStorage.setItem('evaluationContent', JSON.stringify(evaluationList[0]));
			} else {
				localStorage.removeItem('evaluationContent');
			}
			this.$router.push({
				name: 'MedicalEvaluation',
				params: {
					calimsId: id,
					providerName: name,
					providerCode: code
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.page_ {
	position: relative;
	background-color: #fff;
	// min-height:80vh;
	border-radius: 10px;
	.title_ {
		padding: 20px 30px;
		font-weight: bold;
		font-size: 16px;
		border-bottom: 1px solid #f3f3f3;
		margin-bottom: 0;
	}
	.datalist_b {
		min-height: 68vh;
	}
	.datalist_ {
		padding: 30px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		.item_ {
			width: 32%;
			background: #ffffff;
			box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);
			border-radius: 10px;
			padding: 30px 0 0 0;
			margin-right: 2%;
			margin-bottom: 20px;
			&:nth-child(3n + 0) {
				margin-right: 0;
			}
			p {
				margin: 0;
				padding: 0 30px;
			}
			.top_ {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 10px;
				padding: 0 30px;
				> span {
					&:first-child {
						color: #394155;
						font-weight: bold;
						font-size: 16px;
						max-width: 85%;
					}
					&:last-child {
						font-size: 14px;
						display: flex;
						white-space: nowrap;
						align-items: center;
						.circle {
							width: 4px;
							height: 4px;
							background-color: #2c5acc;
							border-radius: 4px;
							display: inline-block;
							margin-right: 5px;
						}
					}
				}
			}
			p {
				font-size: 14px;
				line-height: 25px;
			}
			.bottom_ {
				padding: 15px 20px;
				border-top: 1px solid #f3f3f3;
				color: #2c5acc;
				font-size: 14px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 20px;
				cursor: pointer;
				.icon_ {
					width: 14px;
					height: 14px;
					background: url(../assets/medilinkPC/edit.svg) center center no-repeat;
					background-size: 14px 14px;
					display: inline-block;
					margin-right: 5px;
				}
			}
		}
	}
	.pagination_ {
		// position:absolute;
		padding-bottom: 20px;
		left: 0;
		right: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 30px;
	}
	.nodata_ {
		width: 81px;
		margin: 150px auto 0;
		img {
			width: 81px;
			height: 91px;
		}
	}
}
</style>
